import { ISafeExecuteAsyncAction } from '../../../common/typings/stores';
import { IViewInlLibraryStatusResponse } from '../api/models/viewInlLibraryStatusResponse';
import OrderViewerApiService from '../api/orderViewerApiService';
import { ViewInLibraryStatus } from '../typing/enums';
import { useEffect, useState } from 'react';

function useInLibraryPolling(
	apiService: OrderViewerApiService,
	contentId: number,
	poolInterval: number,
	viewInLibraryStatus: ViewInLibraryStatus,
	safeExecuteAsync: ISafeExecuteAsyncAction,
	action?: (res: IViewInlLibraryStatusResponse) => void
) {
	const [docStatus, setStatus] = useState<IViewInlLibraryStatusResponse | null>(null);
	const [isPolling, setIsPolling] = useState(viewInLibraryStatus === ViewInLibraryStatus.NeedPolling);

	useEffect(() => {
		const getResult = async () => {
			const response: IViewInlLibraryStatusResponse = await safeExecuteAsync(
				() => apiService.checkViewInLibraryStatus(contentId),
				null
			);

			if (response !== null) {
				setStatus(response);
				if (action) {
					action(response);
				}

				if (response.status === ViewInLibraryStatus.Enabled) {
					setIsPolling(false);
				}
			} else {
				setStatus({
					status: ViewInLibraryStatus.Disabled,
					documentId: 0
				});
				setIsPolling(false);
			}
		};

		if (isPolling) {
			const intervalId = setInterval(getResult, poolInterval);
			return () => {
				clearInterval(intervalId);
				setIsPolling(false);
			};
		}
	}, [isPolling]);

	return docStatus;
}

export default useInLibraryPolling;
